import { can } from "../permissions/"

/**
 * @name sharedFields
 * @description Some fields are shared accross all queries, we abstract them away
 * and we also tackle permissions for them
 */

export default () => `
  createdAt
  ${can("readInternals") ? "createdBy{ associatedUser { id name } }" : ""}
  lastModifiedAt
  ${can("readInternals") ? "lastModifiedBy{ associatedUser { id name } }" : ""}
 `
